import CallMade from '@mui/icons-material/CallMade';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { lightGreen } from '@mui/material/colors';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Configuracao from '../util/Configuracao';
import { RESULTADO_JULGAMENTO } from '@/dominio/ResultadoJulgamento';

class IconeEnviadoAoPJe extends Component {
    render() {
        if (!this.props.registro) {
            return null;
        }

        if (
            (this.props.registro.processo.origem === Configuracao.ORIGEM_SIJ &&
                this.props.registro.acordaoTransferido) ||
            (this.props.registro.movimentosTransferidos &&
                this.props.registro.resultadoJulgamento &&
                this.props.registro.resultadoJulgamento.codigo !== RESULTADO_JULGAMENTO.NAO_JULGADO.codigo)
        ) {
            const titulo =
                this.props.registro.processo.origem === Configuracao.ORIGEM_PJE ? 'Enviado ao PJe' : 'Enviado ao eSIJ';

            return (
                <Tooltip title={<Typography>{titulo}</Typography>}>
                    <CallMade sx={{ color: lightGreen[900], cursor: 'default' }} />
                </Tooltip>
            );
        }

        return null;
    }
}

IconeEnviadoAoPJe.propTypes = {
    registro: PropTypes.object.isRequired
};

export default IconeEnviadoAoPJe;
